import { ChipCombinedProps } from './types';

const usePresenter = (props: ChipCombinedProps): ChipCombinedProps => {
  return props;
};

export default usePresenter;
